<template>
  <v-app light>
    <v-toolbar app color="white" :extended="toolbarExtended">

      <v-icon
              v-if="backTo"
              large
              @click="pageMove"
      >
        arrow_back_ios
      </v-icon>

      <v-toolbar-title >
        <router-link :to="shopNameLinkUrl" class="shop_name_link">
        <span class="headline" v-if="shopName.length < 15">{{shopName}}</span>
          <span class="small-headline" v-if="shopName.length >= 15">{{shopName}}</span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>




      <v-badge right overlap color="red" >

        <template v-if="cartNumItems" v-slot:badge>
          <span>{{cartNumItems}}</span>
        </template>
        <v-icon
                large
                color="brown"
                @click="go('/cart')"
        >
          shopping_basket
        </v-icon>

      </v-badge>


      <template v-slot:extension v-if="deliveryProvider && deliveryProvider.dpId">
            {{deliveryProvider.companyName}}
        <v-spacer></v-spacer>
        <a @click.prevent="removeDeliveryProvider">[自分で取りに行く]</a>
      </template>

      <template v-slot:extension v-if="testMode">
        <v-card color="black yellow--text" class="pa-3">
          <h4>テスト用画面です。実際の注文にはご利用いただけません。</h4>
        </v-card>

      </template>




    </v-toolbar>

    <v-content >
<v-alert :value="closeSoonText!=''" icon="new_releases">{{closeSoonText}}</v-alert>
      <router-view></router-view>

      <v-flex xs12 sm6 offset-sm3>
    <v-divider></v-divider>
      <div class="bizHoursDiv ma-3 " v-if="businessHoursVues && showBizHours">
        <h3 class="mb-1">営業時間のご案内</h3>

          <v-layout row wrap >
            <v-flex xs4 class="bgflex"></v-flex>
            <template v-for="i of 2" >
              <v-flex xs4 class="bgflex text-xs-center" :key="'bizCalenderText'+i">
                {{bizHourCalendarText(i)}}
                <br />
                {{bizHourYmdLocalText(i)}}
              </v-flex>

            </template>

          </v-layout>
        <template v-for="serviceName in menu.defalutSettings.serviceProvided" >
          <v-layout row wrap :key="serviceName">
            <v-flex xs4 class="bgflex pl-1">{{businessHoursVues[serviceName]["titleJa"]}}</v-flex>
            <template v-for="dayIndex of 2" >
              <v-flex xs4 :key="dayIndex" class="text-xs-center">
                <template v-if="businessHoursVues[serviceName].days[dayIndex-1].ranges.length">
                  <template v-for="(range,rangeIndex) in businessHoursVues[serviceName].days[dayIndex-1].ranges" >
                  <span :key="rangeIndex">
                    {{range}}<br/>
                  </span>
                  </template>
                </template>

                <span class="red--text" v-if="isClosed(serviceName,dayIndex)">お休み</span>
              </v-flex>

            </template>

          </v-layout>
        </template>

        <v-layout row wrap>
          <v-spacer></v-spacer>
          <div class="pt-3">
            <a @click="go('/bizHours')" class="linkText " >もっと見る</a>
          </div>
        </v-layout>


      </div>
      </v-flex>

    </v-content>

    <v-bottom-nav
            :active.sync="bottomBarSelected"
            :value="true"
            fixed
            app
            color="#333333"
    >
      <v-btn
              color="white"
              flat
              value="home"
              to="/home"
      >
        <span>ホーム</span>
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn
              color="white"
              flat
              value="itemList"
              to="/"
      >
        <span>商品</span>
        <v-icon>create</v-icon>
      </v-btn>

      <v-btn
              color="white"
              flat
              value="cart"
              to="/cart"
      >
        <span>カート</span>
        <v-badge right overlap color="red" >
          <template v-if="cartNumItems" v-slot:badge>
            <span>{{cartNumItems}}</span>
          </template>
          <v-icon>shopping_basket</v-icon>
        </v-badge>
      </v-btn>

      <v-btn
              color="white"
              flat
              value="history"
              to="/history"
      >
        <span>ご注文履歴</span>
        <v-icon>history</v-icon>
      </v-btn>

      <v-btn
              color="white"
              flat
              value="settings"
              to="/settings"
      >
        <span>設定/Lang</span>
        <v-icon>settings</v-icon>
      </v-btn>


    </v-bottom-nav>

    <v-snackbar
            v-model="snackbar"
            vertical
            :timeout=3500
    >
      <v-layout row>
      <v-flex xs11>
      {{ snackbarText }}
      </v-flex>
      <v-flex xs1>
      <v-btn
              color="white"
              flat
              @click="snackbar = false"
      >
        <v-icon>cancel</v-icon>
      </v-btn>
      </v-flex>
      </v-layout>
    </v-snackbar>

    <suspended-full v-if="fullSuspended"></suspended-full>
    <permanently-closed-full v-if="permanentlyClosed"></permanently-closed-full>
  </v-app>


</template>

<script>
  import  { Logger, Auth } from 'aws-amplify';
  const logger = new Logger('App','INFO');
  import { AmplifyEventBus } from 'aws-amplify-vue'
  import { uuid } from 'vue-uuid';
  import moment from 'moment-timezone'
  import { I18n } from 'aws-amplify';
  //const querystring = require('querystring')
  import {MqttMixins} from './mixins/mqtt'
  import SuspendedFull from './components/SuspendedFull'
  import PermanentlyClosedFull from './components/PermanentlyClosedFull'

export default {
  mixins:[MqttMixins],
  name: 'App',
  components: {
    SuspendedFull,
    PermanentlyClosedFull,
  },
  head(){
    return{
      htmlAttrs:{lang:'ja'}
    }
  },
  data () {
    return {
      shopName:I18n.get('Loading...'),
      premiseId:undefined,
      //testMode:false,  //computed
      menu:{"defalutSettings":{"serviceProvided":[]}},
      backTo:false,
      showBizHours:true,
      cart: new Cart(),
      cartNumItems:0,
      businessHours:{},
      businessHoursVues:undefined,
      userSelect:{},
      cognitoId:undefined,
      lang:undefined,
      currency:undefined,
      snackbar:false,
      snackbarText:"",
      bottomBarSelected:'itemList',
      checkIsOpenTimer:undefined,
      closeSoonText:"",
      shopNameLinkUrl:"/",
      toolbarExtended:false,
      catList:[],
      selectedCat:"",
      fullSuspended:false,
      permanentlyClosed:false,
      //deliveryProvider:{}, computed
    }
  },
  created(){
    AmplifyEventBus.$on('setBackTo', this.setBackTo )
    AmplifyEventBus.$on('setBottomBar', this.setBottomBar)
    AmplifyEventBus.$on('requestMenu', this.requestMenu )
    AmplifyEventBus.$on('requestDetail', this.requestDetail )
    AmplifyEventBus.$on('addCart',this.addCart)
    AmplifyEventBus.$on('getCart',this.getCart)
    AmplifyEventBus.$on('getShopNameLang',this.getShopNameLang)
    AmplifyEventBus.$on('getPriceWithTax',this.getPriceWithTax)
    AmplifyEventBus.$on('removeFromCart',this.removeFromCart)
    AmplifyEventBus.$on('setUserSelect', this.setUserSelect)
    AmplifyEventBus.$on('getUserSelect', this.getUserSelect)
    AmplifyEventBus.$on('getCognitoId', this.getCognitoId)
    AmplifyEventBus.$on('addOrder', this.addOrder)
    AmplifyEventBus.$on('customerArrived', this.customerArrived)
    AmplifyEventBus.$on('langChanged', this.langChanged)
    //AmplifyEventBus.$on('checkIsOpen', this.checkIsOpen)
    AmplifyEventBus.$on('showCatMenu', this.showCatMenu)
    AmplifyEventBus.$on('setBizHours', this.setBizHours)
    AmplifyEventBus.$on('setJourney', this.setJourney)

    // initialize store
    this.$store.dispatch('initialize')

  },
  async mounted(){
    //config ga
    this.$gtag.linker({
      'accept_incoming': true,
      domains:[location.hostname, 'localhost','shop.airdt.app']
    })
    //logger.info("query",this.$route) // this does not work when access from subdir such as /detail
    const queryParams = new URLSearchParams(window.location.search)
    logger.info("queryParams",queryParams)
    logger.info("queryParams",queryParams.get('p'))
    if(queryParams.get('p')){
      sessionStorage.setItem('currentPremiseId',queryParams.get('p'))
      sessionStorage.removeItem('reloadAttempt')
      await this.$store.dispatch('setPlaceIdParam',queryParams.get('p'))
      logger.info(this.$store.state)
      this.shopNameLinkUrl = "/?p="+this.$store.state.placeIdParam
      // we keep dp unless user set off
      // RIP dp
      this.deliveryProvider = {}
      /*
      if(this.deliveryProvider && this.deliveryProvider.dpId){
        if(queryParams.get('dp')) {
          this.deliveryProvider.dpId = queryParams.get('dp')
        }
        this.shopNameLinkUrl += "&dp=" + this.deliveryProvider.dpId
        await this.getDeliveryProvider(this.deliveryProvider.dpId)
      }else{
        if(queryParams.get('dp')){
          const dpId = queryParams.get('dp')
          logger.info("dp found: ",dpId)
          await this.getDeliveryProvider(dpId)
          logger.info("deliveryProvider",this.deliveryProvider)
          this.shopNameLinkUrl += "&dp=" + dpId
          localStorage.setItem("dpId",dpId)
        }else{
          if(localStorage.getItem("dpId")){
            const dpId = localStorage.getItem("dpId")
            await this.getDeliveryProvider(dpId)
            logger.info("deliveryProvider",this.deliveryProvider)
            this.shopNameLinkUrl += "&dp=" + dpId
          }
        }
      }
      */
    }else{
      //we remove deliveryProvider if not using p
      this.deliveryProvider = {}
      if(sessionStorage.getItem('currentPremiseId')
              && !sessionStorage.getItem('reloadAttempt')
      ){
        logger.info("attempt to navigate to top")
        sessionStorage.setItem('reloadAttempt',"trying")
        let reloadUrl = ""
        reloadUrl += location.protocol
        reloadUrl += "//"
        reloadUrl += location.hostname
        if(location.port != 443 && location.port != ""){
          reloadUrl += ":"
          reloadUrl += location.port
        }
        reloadUrl += "/?p="
        reloadUrl += sessionStorage.getItem('currentPremiseId')
        location.href = reloadUrl

      }
    }
    this.premiseId = queryParams.get('p')
    logger.info("premiseId",this.premiseId)
    if(this.premiseId){
      await this.$store.dispatch('setPlaceIdParam',this.premiseId)
    }
    const anonymousUser = await Auth.currentCredentials()
    this.cognitoId = anonymousUser.identityId
    logger.info("anonymousUser",anonymousUser.identityId)

    this.$store.commit("setSuspendUntilMT",{})

    const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers"
    const dataToSend = {}
    dataToSend.request = "premiseData"
    dataToSend.premiseId = this.premiseId
    dataToSend.hostname = location.hostname
    dataToSend.cognitoIdentity = anonymousUser.identityId
    logger.info("adt-consumers dataToSend",dataToSend)
    const res = await this.axios.post(apiUrl,dataToSend)
    logger.info("adt-consumers res",res.data)
    this.$store.dispatch('setLocation',res.data) // location

    // temporally suspended?
    if(res.data.suspendUntil){
      this.$store.commit("setSuspendUntilMT",res.data.suspendUntil)
    }
    await this.checkSuspended()

    //permanentlyClosed?
    if(res.data.permanentlyClosed){
      this.$store.commit("setPermanentlyClosedMT",res.data.permanentlyClosed)
      this.permanentlyClosed = true
    }
    //permanently closed if not aguro
    //adt_account_place_id_263614b1-d830-479b-9749-e2a372944f27
    if(res.data.premiseId != "adt_account_place_id_263614b1-d830-479b-9749-e2a372944f27"){
      this.permanentlyClosed = true
    }

    //
    const receivedPremiseId = res.data.premiseId
    await this.$store.dispatch('setPlaceIdParam',receivedPremiseId)
    const menuUrl = "https://menu.airdt.app/"+receivedPremiseId+"?time="+Date.now()
    const menuResult = await this.axios.get(menuUrl).catch(err=>{
      logger.info("error this.axios.get(menuUrl)",err)
      this.shopName = "データ取得に失敗しました。"

    })
    this.menu = menuResult.data
    if(res.data["place-name_ja-JP"]){
      this.shopName = res.data["place-name_ja-JP"]
    }else{
      this.shopName = res.data["place_name"]
    }
    this.$store.dispatch('setShopName',this.shopName)


    //AmplifyEventBus.$emit("shopName",this.shopName)
    this.cart.premiseName = this.shopName

    if(this.$route.query.mode=="local"){
      logger.info("mode:local")
      //this.menu = menu
    }
    logger.info("this.menu",this.menu)
    AmplifyEventBus.$emit("menu",this.menu)
    this.$store.dispatch('setMenu',this.menu)

    //restore saved cart

    if(sessionStorage.getItem('cart')){
      const loadedCart = JSON.parse( sessionStorage.getItem('cart') )
      if(loadedCart.premiseId == this.premiseId){
        this.cart = loadedCart
        this.setVuexCartCurrent()
      }

    }else{
      //try to get vuexCartCurrent
      if(this.$store.state.cartCurrent[this.premiseId] && this.$store.state.cartCurrent[this.premiseId].cart){
        this.cart = this.$store.state.cartCurrent[this.premiseId].cart
      }
      this.setVuexCartCurrent()
    }


    this.lang = this.menu.defalutSettings.defaultLang
    this.currency = this.menu.defalutSettings.currency
    //logger.info("lang",this.menu.defalutSettings.defaultLang)
    moment.locale(this.lang)
    this.checkBusinessHours()
    //same as above but with vuex businessHoursVues
    this.businessHoursVues = this.$store.getters.businessHours(moment())
    logger.info("businessHoursVues",this.businessHoursVues)
    // error if no adt when dp
    if(localStorage.getItem("dpId")){
      if(!this.businessHoursVues.adt){
        alert("この店舗では配達をご利用いただけません。ご自身で取りに行くためのページを表示します。")
        this.removeDeliveryProvider()
      }
    }


    // page move if page param set
    if(this.$route.query.page && this.$route.query.page == "orderDetail"){
      this.go("orderDetail/?orderId="+this.$route.query.orderId)
    }

    if(this.$route.query.page && this.$route.query.page == "itemDetail"){
      this.go("detail/?itemId="+this.$route.query.itemId)
    }
    //http://localhost:9007/?p=adt_account_place_id_7a0433d4-621c-43a9-b64d-bd27903faa90&page=itemDetail&itemId=item_%E6%9C%AC%E6%97%A5%E3%81%AE%E3%83%9B%E3%83%83%E3%83%88%E3%82%B3%E3%83%BC%E3%83%92%E3%83%BC

    //gen catList
    this.genCatList()

    // timer to show close hour
    this.checkIsOpen( moment() )
    this.checkIsOpenTimer = setInterval(
            ()=>{
              this.checkIsOpen( moment() )
            }
            ,60000)
    await this.$store.dispatch('setAppReady',true)

    //mqtt
    await this.setupMqttClient()
    // send journey
    this.sendJourney("system","loadedAndReady")
  },
  beforeDestroy () {
    clearInterval(this.checkIsOpenTimer)
  },
  methods:{

    checkSuspended:async function(){
      const suspendUntil = this.$store.state.suspendUntil
      logger.info("checking if this promise is suspended",suspendUntil)
      if(suspendUntil.time){
        const targetTime = moment(suspendUntil.time)
        if(targetTime.isAfter(moment())){
          logger.info("suspended until: ",targetTime.format())
          this.fullSuspended = true
        }
      }
    },
    setVuexCartCurrent:function(){
      //prepare current cart
      this.cart.total = getTotalPrice(this.cart.items,"subtotal")
      //subtotal is price x num of purchase
      this.cart.feeTotal = getTotalPrice(this.cart.items,"fee")
      this.cart.lang = this.lang
      this.cart.currency = this.currency
      //this.cart.premiseId = sessionStorage.getItem('currentPremiseId')
      this.cart.premiseId = this.$store.state.placeIdParam
      this.cart.premiseName = this.shopName

      //store to vuex
      const cartPremiseId = this.cart.premiseId
      const premiseId = this.premiseId
      logger.info("setVuexCartCurrent cartPremiseId",cartPremiseId)
      if(premiseId){
        const cartCurrent = {}

        if(this.$store.state.cartCurrent[premiseId]){
          cartCurrent[premiseId] = this.$store.state.cartCurrent[premiseId]
        }else{
          cartCurrent[premiseId] = {}
        }

        if(cartPremiseId && premiseId == cartPremiseId){
          cartCurrent[premiseId].cart = this.cart
          cartCurrent[premiseId].updated = Date.now()
          this.$store.commit("setCartCurrentMT",cartCurrent)
        }else{
          // if you want to keep cart on other shop, consider to alter below
          this.cart = new Cart()
          cartCurrent[premiseId].cart = this.cart
          cartCurrent[premiseId].updated = Date.now()
          this.$store.commit("setCartCurrentMT",cartCurrent)
        }
      }

    },
    removeDeliveryProvider:async function(){
      this.deliveryProvider = {}
      localStorage.removeItem("dpId")
      const getHostnameResult = await this.getHostname()
      logger.info("getHostnameResult",getHostnameResult)
      if(getHostnameResult.result == "success"
      && getHostnameResult.Item
              && getHostnameResult.Item.hostname){
        location.href = "https://" + getHostnameResult.Item.hostname
      }else{
        location.href = "https://dikitoon.com/"
      }
    },
    getHostname:async function(){
      const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/getHostname"
      const dataToSend = {}
      dataToSend.request = "getHostname"
      dataToSend.hostname = location.hostname
      dataToSend.premiseId = this.$store.state.placeIdParam
      dataToSend.cognitoIdentity = this.cognitoId
      logger.info("getHostname",dataToSend)
      const res = await this.axios.post(apiUrl,dataToSend)
      logger.info("getHostname result",res.data)
      return res.data
    },
    getDeliveryProvider:async function(dpId){
      const apiUrl = "https://24d3ujue09.execute-api.ap-northeast-1.amazonaws.com/default/adt-consumers/deliveryProvider"
      const dataToSend = {}
      dataToSend.request = "deliveryProvider"
      dataToSend.dpId = dpId
      dataToSend.hostname = location.hostname
      dataToSend.premiseId = this.$store.state.placeIdParam
      dataToSend.cognitoIdentity = this.cognitoId
      //logger.info("dpId",dataToSend)
      const res = await this.axios.post(apiUrl,dataToSend)
      logger.info("deliveryProvider",res.data)
      if(res.data.result == "success"){
        this.deliveryProvider = res.data.Item
      }


    },
    bizHourCalendarText:function(i){
      //logger.info("bizHourCalendarText",i)
      const num = i - 1
      let res=""
      if(this.businessHoursVues && this.businessHoursVues.dayTextLang){
        res += this.businessHoursVues.dayTextLang[num].calendar[this.lang]
      }
        return res
    },
    bizHourYmdLocalText:function(i){
      const num = i - 1
      let res=""
      if(this.businessHoursVues && this.businessHoursVues.dayTextLang){
        res += this.businessHoursVues.dayTextLang[num].ymdLocal[this.lang]
      }
      return res
    },

    showCatMenu:function(showHide){
      if(showHide == "show"){
        this.toolbarExtended = true
      }else{
        this.toolbarExtended = false
      }
    },
    setBizHours:function(bool){
      this.showBizHours = bool
    },
    genCatList:function(){
      this.catList = []
      for(let i in this.menu.itemsAndInventories.categoriesAndOrder.order) {
        const catId = this.menu.itemsAndInventories.categoriesAndOrder.order[i]
        const cat = this.menu.itemsAndInventories.categoriesAndOrder.categories[catId]
        const catListItem = {}
        catListItem.catId = encodeURIComponent(catId)
        catListItem.catName = cat.name[this.lang]
        this.catList.push(catListItem)
      }
      this.selectedCat = this.catList[0].catId
      //logger.info("genCatList",this.catList)
    },
    go: function(destination){
      console.log("going to "+destination)
      this.$router.push(destination)
    },
    getCart:function(){
      const dataToEmit = {}
      this.cart.total = getTotalPrice(this.cart.items,"subtotal")
      //subtotal is price x num of purchase
      this.cart.feeTotal = getTotalPrice(this.cart.items,"fee")
      this.cart.lang = this.lang
      this.cart.currency = this.currency
      this.cart.premiseId = sessionStorage.getItem('currentPremiseId')
      this.cart.premiseName = this.shopName
      dataToEmit.cart = this.cart
      dataToEmit.defalutSettings = this.menu.defalutSettings
      dataToEmit.businessHours = this.businessHours
      AmplifyEventBus.$emit('cartCurrent',dataToEmit)
    },
    removeFromCart:function(cartItemId){
      for(let i in this.cart.items){
        if(this.cart.items[i].cartItemId==cartItemId){
          //console.log("found uuid removed")
          this.cart.items.splice(i,1)
        }
      }
      this.getCart()
      this.setVuexCartCurrent()
    },
    addCart:function(data){
      const cartItem = Object.assign({},data)
      // calculate adt fees
      const item = this.menu.itemsAndInventories.items[cartItem.itemId]
      logger.info("numOfPurchase",cartItem.numOfPurchase)
      cartItem.fee = getFee(item,'adt',cartItem.priceDiff) * cartItem.numOfPurchase
      logger.info("fee",cartItem.fee)
      this.cart.items.push(cartItem)
      logger.info("cartItem",cartItem)
      logger.info("cart",this.cart)
      //snackbar
      this.snackbarText = cartItem.nameWithOption + " を追加しました"
      this.snackbar = true
      this.setVuexCartCurrent()
    },
    setBackTo:function(destination){
      //logger.info("setBackTo",destination)
      if(destination=="none"){
        this.backTo = false
      }else{
        this.backTo = destination

      }

    },
    sendJourney:async function(key,value){

      const apiUrl = "https://z9pget78wl.execute-api.ap-northeast-1.amazonaws.com/default/dikitoon-customer-journey"
      const dataToSend = {}
      dataToSend.key = key
      dataToSend.value = value
      dataToSend.premiseId = this.$store.state.placeIdParam
      dataToSend.hostname = location.hostname
      dataToSend.cognitoId = this.cognitoId
      dataToSend.userAgent = navigator.userAgent
      dataToSend.referrer = document.referrer
      dataToSend.href = location.href
      //logger.info("sendJourney dataToSend",dataToSend)
      try{
        await this.axios.post(apiUrl,dataToSend)
      }catch(e){
        logger.info("sendJourney error",e)
      }

    },
    setJourney:async function(obj){
      if(obj.key && obj.value){
        await this.sendJourney(obj.key,obj.value)
      }
    },

    setBottomBar:function(activeButton){
      this.bottomBarSelected = activeButton
    },
    pageMove:function(){
      if(this.backTo){
        this.$router.push(this.backTo)
      }

    },
    getPriceWithTax:function(data){
      //logger.info("getPriceWithTax",data)
      const priceNaked = calcPriceWithTax(this.menu,data.itemId,data.priceDiff)
      const dataToEmit = {}
      dataToEmit.itemId = data.itemId
      dataToEmit.priceDiff = data.priceDiff
      dataToEmit.priceNaked = priceNaked
      // to show original price
      dataToEmit.originalPrice = this.getOriginalPrice(data.itemId)
      //dataToEmit.priceBeforeAdt =
      AmplifyEventBus.$emit("priceWithTax",dataToEmit)
    },
    getOriginalPrice:function(itemId){
      let res
      const item = this.menu.itemsAndInventories.items[itemId]
      const keyServiceName = this.menu.defalutSettings.serviceProvided[0]
      if(item.tax && item.tax == "excluded"){
        res = item.priceWithoutTax * ( 1 + this.menu.defalutSettings.taxRate[keyServiceName] )
      }else{
        if(item.priceIncludeTax && item.priceIncludeTax[keyServiceName]){
          res = item.priceIncludeTax[keyServiceName]
        }
      }
      return res
    },
    requestMenu:function(){
        if(this.menu){
          AmplifyEventBus.$emit("menu",this.menu)
        }
    },
    requestDetail:function(itemId){
      if(this.menu){
        const menuSingle = {
          defalutSettings:this.menu.defalutSettings,
          item:this.menu.itemsAndInventories.items[itemId],
          // itemId is on query when requested from Detail
          candidatesDetail:this.menu.itemsAndInventories.candidatesDetail,
          candidatesGroup:this.menu.itemsAndInventories.candidatesGroup,
          optionDetail:this.menu.itemsAndInventories.optionDetail,
        }
        AmplifyEventBus.$emit("detail",menuSingle)
      }
    },
    checkBusinessHours:function(){
      //logger.info("lang",this.lang)

      this.businessHours = businessHours(this.menu.defalutSettings.serviceProvided,this.menu.businessHours)


    },
    setUserSelect:function(userSelect){
      this.userSelect = userSelect
    },
    getUserSelect:function(){
      logger.info("emitting userSelect",this.userSelect)
      AmplifyEventBus.$emit("currentUserSelect",this.userSelect)
    },
    getCognitoId:function(){
      AmplifyEventBus.$emit("cognitoId",this.cognitoId)
    },
    getShopNameLang:function(){
      const res = {}
      res.shopName = this.shopName
      res.lang = this.lang
      AmplifyEventBus.$emit("shopNameLang",res)
    },
    addOrder:function(data){
      let premiseName = ""
      if(data.premiseName){
        premiseName = data.premiseName
      }else{
        if(data.deliveryProvider){
          premiseName = data.deliveryProvider.chargeJobsResult[0].chargeResult.premiseName
        }
      }
      //snackbar
      this.snackbarText = premiseName + " に注文を送信しました"
      this.snackbar = true
      this.cart = new Cart()
      this.setVuexCartCurrent()
    },
    customerArrived:function(data){
      this.snackbarText = data + " にお客様の到着を送信しました。車内でお待ちください。"
      this.snackbar = true
    },
    langChanged:function(data){
      this.lang = data
      this.menu.defalutSettings.defaultLang = data
      // above is NOT a good idea to change default lang. Better to set current language instead.
      I18n.setLanguage(data)
      console.log("lang changed to " + data)
    },
    checkIsOpen:function(currentMoment){
      const vuexBusinessHours = this.$store.getters.businessHours(moment())
      //logger.info("checkIsOpen businessHours",vuexBusinessHours)
      const keyServiceName = this.$store.state.menu.defalutSettings.serviceProvided[0]
      //logger.info("keyServiceName",keyServiceName)
      if(vuexBusinessHours[keyServiceName].days[0].timeToCompletelyClose < 60){
        logger.info("the shop close soon")
        this.closeSoonText = "あと" + vuexBusinessHours[keyServiceName].days[0].timeToCompletelyClose + "分で閉店します"
      }else{
        this.closeSoonText = ""
      }
      if(!vuexBusinessHours[keyServiceName].days[0].timeToCompletelyClose && !vuexBusinessHours[keyServiceName].days[0].isOpen ){
        this.closeSoonText = I18n.get("Out of business hours")
      }
      // Check business is before opening time
      if(vuexBusinessHours[keyServiceName].days[0].ranges[0]){
        const firstRangeArray = vuexBusinessHours[keyServiceName].days[0].ranges[0].split("-")
        let firstRangeStart = firstRangeArray[0]
        if(firstRangeStart.length == 4){
          firstRangeStart = "0" + firstRangeStart
        }

        const currentDayString = currentMoment.format("Y-MM-DDT") + firstRangeStart + ":00+09:00"
        //logger.info("currentDayString",currentDayString)
        if(currentMoment.isBefore(currentDayString)){
          logger.info("not open yet")
          this.closeSoonText = "営業時間前です。"
        }
      }


    },
    isClosed:function(serviceName,i){
      if(i>=0 && serviceName){
        if(!this.businessHoursVues[serviceName].days[i-1].ranges){
          return true
        }else{
          if(this.businessHoursVues[serviceName].days[i-1].ranges.length>0){
            return false
          }else{
            return true
          }
        }
      }


    }

  },
  computed:{
    testMode:function(){
      return this.$store.state.testMode
    },
    deliveryProvider: {
      get() {
        return this.$store.state.deliveryProvider
      },
      set(value) {
        this.$store.commit("setDeliveryProviderMT", value)
      }
    }
  },
  watch: {
    'cart.items': {
      handler:function(newVal){
        console.log("cart:"+newVal.length)
        this.cartNumItems = newVal.length
      }
    },
    cart: {
      handler(val) {
        sessionStorage.setItem('cart',JSON.stringify(val))
      }, deep: true,
    },
    shopName: function(newVal){
      logger.info("shopName updated: " , newVal)
      document.title = newVal
              //document.title = newVal
    },
    '$route':function(to,from){
      logger.info("route to: ",to)
      logger.info("route from: ",from)
    },
    premiseId:function(newVal){
      logger.info("premiseId updated",newVal)
      if(newVal && newVal.substr(0,5) == "test-" && newVal.substr(-5,5) == "-test"){
        this.$store.commit("setTestModeMT",true)
      }else{
        this.$store.commit("setTestModeMT",false)
      }
    }

    /*
    bottomBarSelected: {
      handler:function(val){
        console.log("bottomNav:"+val)
        if(val=="home"){
          this.$router.push("/")
        }else {
          this.$router.push("/"+val)
        }
      }

    },
    */
  }
}

  function Cart(){
    this.items = []
    this.uuid = "cart_" + uuid.v4()
    this.created = moment().format()
    this.total = 0
    this.feeTotal = 0
    this.lang = ""
    this.currency = ""
    this.premiseId = ""
    this.premiseName = ""
  }

  const calcPriceWithTax = (menu,itemId,diff=0)=>{
    // diff is price affect by option choice
    if(!menu || !menu.itemsAndInventories){
      return
    }
    const item = menu.itemsAndInventories.items[itemId]
    const keyServiceName = menu.defalutSettings.serviceProvided[0]
    let priceNaked
    if(item.tax == "excluded"){
      const priceWithoutTax = item.priceWithoutTax + diff
      if(item.includeAdtFees){
        priceNaked = priceWithoutTax * ( 1 + menu.defalutSettings.taxRate[keyServiceName] )
      }else{ // exclude adt fees
        const subTotal = getPriceWithAdt(item,priceWithoutTax,keyServiceName)
        /*
        if(item.adtFeeType == "ratio"){
          subTotal = ( priceWithoutTax * ( 1 + item.adtFeesRatio.adt) )
        }else { // fixed
          subTotal = ( priceWithoutTax  + item.adtFeesFixed.adt )
        }
         */
        priceNaked = subTotal * ( 1 + menu.defalutSettings.taxRate[keyServiceName] )
      }

    }else{ // included tax
      const priceIncludeTax = item.priceIncludeTax[keyServiceName] + diff
      if(item.includeAdtFees){
        priceNaked = priceIncludeTax
      }else{ // exclude adt fees
        priceNaked = getPriceWithAdt(item,priceIncludeTax,keyServiceName)

      }
    }
    return priceNaked
  }

  const getFee = (item,serviceType='adt',diff=0) =>{
    // diff is price affect by option choice
    let priceBeforeAdtfee
    if(item.tax == "excluded"){
      priceBeforeAdtfee = item.priceWithoutTax + diff
    }else{
      priceBeforeAdtfee = item.priceIncludeTax[serviceType] + diff
    }
    if(item.adtFeeType == "ratio"){
      return item.adtFeesRatio[serviceType] * priceBeforeAdtfee
    }else{ //fixed
      return item.adtFeesFixed[serviceType]
    }
  }

  const getPriceWithAdt = (item,priceWithoutAdt,keyServiceName) => {
    let res

    if(item.adtFeeType == "ratio"){
      res = ( priceWithoutAdt * ( 1 + item.adtFeesRatio[keyServiceName]) )
    }else { // fixed
      res = ( priceWithoutAdt  + item.adtFeesFixed[keyServiceName] )
    }
    return res
  }

  const getTotalPrice = (items,key) => {
    let totalPrice = 0
    for(let i in items){
      totalPrice += items[i][key]
    }
    totalPrice = Math.ceil(totalPrice)
    console.log("total "+ key + " :"+totalPrice)
    return totalPrice
  }

  const businessHours = (services,businessHours) => {

    const numberOfBusinessDayNeedToFind = 36

    const res = {}

    // dayText


    for(let j in services){
      const targetService = services[j]
      let isOpen = false
      let businessHoursText = ""
      let dayTextAll = ""
      const days = []


      for(let i=0;i<=numberOfBusinessDayNeedToFind;i++){
        const targetDay = moment().add(i,'days')
        const dayString = targetDay.format("Y-MM-DD")

        if(!businessHours[dayString]){
          const hoursByRule = getBusinessHourByRule(businessHours,dayString)
          if(hoursByRule){
            businessHours[dayString] = hoursByRule
          }
        }

        //console.log('checking business day after ' + i +' days: ' + targetDay.format("Y-MM-DD"))
        if(i <= 1 || businessHours[dayString] && businessHours[dayString][targetService].length > 0){
          //console.log("found buziness day")

          const bizHourRes = getDayDetail(businessHours,dayString,targetService,i)
          //logger.info("bizHoursRes: ",bizHourRes)
          dayTextAll += bizHourRes.text
          if(bizHourRes.isOpen){
            isOpen = true
          }
          days.push(bizHourRes)


        }
      }

      businessHoursText += moment().format('llll') + "現在、"
      if(isOpen){
        businessHoursText += "営業中です。\n"
      }else{
        businessHoursText += "営業時間外です。\n"
      }
      businessHoursText += " "
      businessHoursText += dayTextAll

      let titleJa = ""
      switch(targetService){
        case "adt":
          titleJa = "お車にお届け"
              break;
        case "dineIn":
          titleJa = "店内予約"
              break;
        case "pickUp":
          titleJa = "持帰り予約"
      }

      res[targetService] = {}
      res[targetService].isOpen = isOpen
      res[targetService].businessHoursText = businessHoursText
      res[targetService].days = days
      res[targetService].titleJa = titleJa


    }

    //

    logger.info("businessHours",res)



    return res

  }

  const getBusinessHourByRule = (businessHours,dayString) => {
    const momentOfTheDay = moment(dayString)
    const dayNum = momentOfTheDay.format('E')
    let patternId = businessHours.patterns["day"+dayNum]

    //holidays
    const holidays={}
    for(let i in businessHours.holidays){
      const holidayArray = businessHours.HolidayDetail[businessHours.holidays[i]]
      for(let dayText in holidayArray){
        holidays[dayText] = holidayArray[dayText]
      }
    }
    //override on the holiday
    if(holidays[dayString]){
      patternId = businessHours.patterns["HolidayIs"+dayNum]
    }

    //override day next holiday
    const aDayAfterHoliday = momentOfTheDay.add(-1,'day')
    const aDayAfterHolidayYmd = aDayAfterHoliday.format('Y-MM-DD')
    //console.log("aDayAfterHolidayYmd: " + aDayAfterHolidayYmd)
    if(holidays[aDayAfterHolidayYmd]){
      patternId = businessHours.patterns["ADayAfterHolidayIs"+dayNum]
    }

    //override day before holiday
    const aDayBeforeHoliday = momentOfTheDay.add(2,'day')
    const aDayBeforeHolidayYmd = aDayBeforeHoliday.format('Y-MM-DD')
    //console.log("aDayBeforeHolidayYmd: " + aDayBeforeHolidayYmd)
    if(holidays[aDayBeforeHolidayYmd]){
      patternId = businessHours.patterns["ADayBeforeHolidayIs"+dayNum]
    }


    if(patternId && businessHours.PatternDetail[patternId]){
      return businessHours.PatternDetail[patternId]
    }else{
      return false
    }
  }

  const getDayDetail = (businessHours,dayText,targetService,distanceToToday) =>{
    const res = {}
    res.distanceToToday = distanceToToday
    res.dayTextLang = moment(dayText).format('M月D日(dd)')
    let text = ""

    switch(distanceToToday){
      case 0:
        res.calendarText = "本日"
        break
      case 1:
        res.calendarText = "明日"
        break
      case 2:
        res.calendarText = "明後日"
        break
      default:
        res.calendarText = distanceToToday + "日後"
    }

    if(businessHours[dayText]){
      const ranges = businessHours[dayText]
      //logger.info("ranges",ranges[targetService])
      res.ranges = ranges[targetService]
      res.isBusinessDay = true
      res.dayText = dayText



      text += res.calendarText
      text += " "

      text += res.dayTextLang
      text += "の営業時間は、"
      res.rangesLang = []
      res.times = {}
      res.timeName = {}

      for(let i in ranges[targetService]){
        const range = ranges[targetService][i]

        //logger.info(range)
        const rangeArray = range.split('-')
        const start =  dayText + " " + rangeArray[0]
        const startMoment = moment( moment(start) )
        let end =  dayText + " " + rangeArray[1]
        // if end time is more than 23:59 eg 27:00 = 3am next day
        const endTimeArray = rangeArray[1].split(':')
        const first2digitsOfEnd = parseInt( endTimeArray[0] )
        //logger.info("first2digitsOfEnd",first2digitsOfEnd)
        if(first2digitsOfEnd > 23){
          const nextDayText = moment(dayText).add(1,'day').format("Y-MM-DD")
          let timeNextDay = first2digitsOfEnd - 24
          if(timeNextDay<10){
            timeNextDay = "0" + timeNextDay
          }
          end = nextDayText + " " + timeNextDay + ":" + endTimeArray[1]
        }
        const endMoment = moment( moment(end) )

        const lang = {}
        lang.start = moment(start).format('Ah時') + showMin(start)
        lang.end = moment(end).format('Ah時') + showMin(end)
        lang.startEnd = lang.start + "から" + start + lang.end
        res.rangesLang.push(lang)
        const duration = endMoment.diff(startMoment,'minutes')
        const numTimes = Math.floor( duration / 15 )


        const targetMoment = moment( moment(start) )
        for(let j=0;j<=numTimes;j++){
          let target
          if(j==0){
            target = targetMoment
          }else{
            target = targetMoment.add( 15,'minutes')
          }

          const hour = target.format("H")
          if(j==0 && !res.times.startHour){
            res.times.startHour = hour
          }
          if(j == numTimes ){
            res.times.endHour = hour
          }
          if(!res.times[hour]){
            res.times[hour] = []
          }
          res.times[hour].push(target.format("HH:mm"))
          if(!res.timeName[hour]){
            res.timeName[hour] = target.format('Ah時')
          }
        }

        text += lang.startEnd

        if(i != ranges[targetService].length - 1){
          text += "と"
        }

        if( moment().isBetween(start,end) ){
          res.isOpen = true
          res.timeToClose = endMoment.diff(moment(),'minutes')
          if(i < ranges[targetService].length - 1){
            res.willOpenAgain = true
          }else{
            res.willOpenAgain = false
          }
        }
        //beforeOpen = false
        //let closedAlready = false
        //let willOpen = false
        //let startOnDay = ""
        //let endOnDay = ""
        if(i==0){
          if(moment().isBefore(start) ){
            res.beforeOpen = true
            res.timeToOpen = startMoment.diff(moment(),'minutes')
          }
        }
        if(i== ranges[targetService].length - 1 ){
          if(moment().isAfter(end) ){
            res.closedAlready = true
          }else{
            res.closedAlready = false
            res.timeToCompletelyClose = endMoment.diff(moment(),'minutes')
          }
        }
      }
      text += "です。\n"
    }else{
      res.isBusinessDay = false
      text += moment(dayText).format('M月D日(dd)')
      text += "はお休みです。\n"
    }



    res.text = text
    return res
  }

  const showMin = (timeText) => {
    let res
    if(moment(timeText).format('m') == '0'){
      res = ""
    }else{
      res = moment(timeText).format('m分')
    }
    return res
  }


  const addDict = (enKey,jaStr) =>{
    dict.ja[enKey]=jaStr
    dict.en[enKey]=enKey
  }

  const dict = {
    'ja':{
      //'ただいま営業時間外です':'ただいま営業時間外です',
      //'Loading...':"店名を読込中"
    },
  'en':{
    //'ただいま営業時間外です':'Out of business hours',
    //'Loading...':"Loading..."
  }
}

  addDict('Out of business hours',"ただいま営業時間外です")
  addDict('Loading...',"店名を読込中")


  I18n.putVocabularies(dict);

</script>
<style>

  .theme--light.application{
    background-color:#f5f1ed;
  }
  .pre{
    white-space: pre-wrap;
  }

  .cart_item{
    height:50px;
    overflow:auto;
    word-wrap:break-word;
    white-space:pre-wrap;
  }

  a .headline{
    color:black;
    font-weight: bolder;
  }

  a .small-headline{
    color:black;
  }

  a.shop_name_link{
    text-decoration: none;
    white-space:break-spaces;
    font-weight: bolder;
  }

  .theme--light.v-bottom-nav .v-btn:not(.v-btn--active){
    color:white !important;
  }

  .v-item-group.v-bottom-nav .v-btn--active{
    background-color: black !important;
  }

  .v-item-group.v-bottom-nav .v-btn{
    min-width:60px;
  }

  .theme--light.v-bottom-nav .v-btn:not(:last-child){
    border-right:white dashed 1px;
  }


  .bizHoursDiv{
    background-color: white;
    border-radius: 12px;
    padding:20px;

  }

  .bizHoursDiv .flex{
    color:#858585;
    border:1px solid #d3c6bf;
  }

  .bizHoursDiv .bgflex{
    background-color: #ece6e3;
  }

  .linkText{
    text-decoration: none;
    font-weight: bold;
  }

</style>